var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-chart',{attrs:{"chartType":"ve-ring","chartData":_vm.chartData,"chartConfig":_vm.chartConfig,"chartSettings":_vm.chartSettings,"loading":_vm.loading,"chartEvents":_vm.chartEvents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }